import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=01e63142&"
import script from "./Inscription.vue?vue&type=script&lang=ts&"
export * from "./Inscription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports